// extracted by mini-css-extract-plugin
module.exports = {"App":"DrinkCard_App__PYA7U","DrinkCard":"DrinkCard_DrinkCard__1jBea","Overlay":"DrinkCard_Overlay__2jdks","Container":"DrinkCard_Container__DMbnc"};